export function isArrNotEmpty(arr: any[]) {
  return arr && arr[0];
}
